import React from "react";
import Link from "next/link";
import styles from "./faq-more-help.module.scss";

function FAQMoreHelp() {
  return (
    <p className={styles.faqMoreHelp}>
      <strong>Not what you’re looking for?</strong> Try searching with different keywords or look at the topics on our{" "}
      <Link data-test="customer-services-link" href="/">
        Customer Services page
      </Link>
      .
    </p>
  );
}

export default FAQMoreHelp;
